import React from 'react';
import { motion } from 'framer-motion';
import { Users, ArrowRight } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { teamSites } from '../data';
export function TeamsPage() {
  return <>
      <PageHeader title="Teams & Sites" subtitle="Spaces for every team to share news, files, and discussion." data-id="element-721" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-722">
        {teamSites.map((t, i) => <motion.button key={t.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="text-left bg-white rounded-xl border border-navy-100 overflow-hidden hover:shadow-md transition-shadow group" data-id="element-723">
            <div className={`h-20 ${t.color} relative`} data-id="element-724">
              <span className="absolute -bottom-6 left-5 w-12 h-12 rounded-xl bg-white shadow flex items-center justify-center text-navy-600" data-id="element-725">
                <Users className="w-6 h-6" data-id="element-726" />
              </span>
            </div>
            <div className="p-5 pt-8" data-id="element-727">
              <h3 className="font-serif font-bold text-lg text-navy-900" data-id="element-728">
                {t.name}
              </h3>
              <p className="text-sm text-navy-500 mt-1 mb-3 leading-relaxed" data-id="element-729">
                {t.description}
              </p>
              <div className="flex items-center justify-between" data-id="element-730">
                <span className="text-xs font-semibold text-navy-400" data-id="element-731">
                  {t.members} members
                </span>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600 group-hover:gap-2 transition-all" data-id="element-732">
                  Open <ArrowRight className="w-3.5 h-3.5" data-id="element-733" />
                </span>
              </div>
            </div>
          </motion.button>)}
      </div>
    </>;
}